import { Code2, LineChart, QrCode, type LucideIcon } from 'lucide-react';
import { Card } from '../../../components/ui/Card';
import { cn } from '../../../lib/utils';

interface Feature {
  icon: LucideIcon;
  tile: string;
  title: string;
  body: string;
}

const FEATURES: Feature[] = [
  {
    icon: LineChart,
    tile: 'bg-brand-blue/15 text-info',
    title: 'Realtime analytics',
    body: 'Clicks, countries, devices, browsers and referrers, updated as they happen.',
  },
  {
    icon: QrCode,
    tile: 'bg-brand-teal/15 text-link',
    title: 'QR codes & domains',
    body: 'Export PNG or SVG at any size. Put links on your own domain.',
  },
  {
    icon: Code2,
    tile: 'bg-success/15 text-success',
    title: 'Developer API',
    body: 'Create and manage links programmatically with keyed, rate-limited access.',
  },
];

export function Features() {
  return (
    <section id="features" className="scroll-mt-20 bg-bg">
      <div className="mx-auto max-w-[1240px] px-5 py-12 sm:px-8 sm:py-16">
        <h2 className="sr-only">Features</h2>
        <ul className="grid gap-5 md:grid-cols-3">
          {FEATURES.map(({ icon: Icon, tile, title, body }) => (
            <li key={title}>
              <Card padding="lg" className="h-full">
                <span className={cn('inline-flex size-12 items-center justify-center rounded-control', tile)} aria-hidden>
                  <Icon className="size-6" />
                </span>
                <h3 className="mt-8 text-xl font-semibold text-text">{title}</h3>
                <p className="mt-3 leading-relaxed text-text-2">{body}</p>
              </Card>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
